import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import HomeTestingUserDetail from './HomeTestingUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyHomeTestingUserDetail } from './companyHomeTestingApi';

/**
 * Company Home Testing → one employee's/member's kit profile.
 * Reuses the shared detail page with the company-scoped fetcher (the backend
 * 404s any user who doesn't belong to this company).
 */
const CHomeTestingUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Testing Profile | Shoorah</title>
      </Helmet>
      <HomeTestingUserDetail
        fetcher={fetchCompanyHomeTestingUserDetail}
        backPath={`/${slug}/home-testing/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CHomeTestingUserDetail;
